export default __webpack_public_path__ + "static/media/e_with_crown_logo.b68fe218.png";